import { apiClient } from '@/services/ApiClient.js'

import { query_builder } from '../../utilities/helpers'

export default {
  getRetailers(query) {
    return apiClient
      .get('retailers', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerCount(query) {
    return apiClient
      .get('retailers/count', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailer(id) {
    return apiClient
      .get('retailers/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerByTin(tin) {
    return apiClient
      .get('retailers/get-retailer-by-tin?tin=' + tin)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSubRetailers(id, query) {
    return apiClient
      .get('retailers/' + id + '/sub-retailers', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerUser(retailerId, id) {
    return apiClient
      .get('retailers/' + retailerId + '/retailer-users/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editRetailer(id, retailer) {
    return apiClient
      .patch('retailers/' + id, retailer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteRetailer(retailerId) {
    return apiClient
      .delete('retailers/' + retailerId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editRetailerAddress(retailerId, address) {
    return apiClient
      .patch('retailers/' + retailerId + '/update-address', address)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editRetailerFinance(retailerId, ibans) {
    return apiClient
      .patch('retailers/' + retailerId + '/update-finance', ibans)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editRetailerUser(retailerId, id, retailerUser) {
    return apiClient
      .patch('retailers/' + retailerId + '/retailer-users/' + id, retailerUser)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannel(id, salesChannelId) {
    return apiClient
      .get('retailers/' + id + '/sales-channels/' + salesChannelId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannels(id) {
    return apiClient
      .get('retailers/' + id + '/sales-channels')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editSalesChannels(retailerId, salesChannelsId) {
    return apiClient
      .patch('retailers/' + retailerId + '/sales-channels/' + salesChannelsId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteSalesChannels(id, salesChannelsId, salesChannels) {
    return apiClient
      .delete('retailers/' + id + '/sales-channels/' + salesChannelsId, salesChannels)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getStatistics(id, query) {
    return apiClient
      .get('retailers/' + id + '/statistics', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCategories(id) {
    return apiClient
      .get('retailers/' + id + '/categories')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachCategory(id, categoryId) {
    return apiClient
      .patch('retailers/' + id + '/categories/' + categoryId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  detachCategory(id, categoryId) {
    return apiClient
      .delete('retailers/' + id + '/categories/' + categoryId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportRetailers(query) {
    return apiClient
      .get('retailers-export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportRetailerUsers(query) {
    return apiClient
      .get('retailer-user-export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportRetailersMonthlySales(query) {
    return apiClient
      .get('retailers-monthly-sales-export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getGoals(id) {
    return apiClient
      .get('retailers/' + id + '/goals')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachGoal(id, goalId) {
    return apiClient
      .patch('retailers/' + id + '/goals/' + goalId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  detachGoal(id, goalId) {
    return apiClient
      .delete('retailers/' + id + '/goals/' + goalId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateLocation(id, location) {
    return apiClient
      .post('retailers/' + id + '/update-location/', {
        location: location
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportRetailerPaymentList() {
    return apiClient
      .get('export-retailer-payment-list')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportRetailerFastPaymentList() {
    return apiClient
      .get('export-retailer-fast-payment-list')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportKit(query, allowedFilters, kit) {
    let queryStringWithUrl = query_builder('retailers/export-kit', query, allowedFilters)

    return apiClient
      .post(queryStringWithUrl.build(), {
        export_kit: kit
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSubRetailer(retailerId, subRetailer) {
    return apiClient
      .post('retailers/' + retailerId + '/sub-retailers', subRetailer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateSubRetailer(retailerId, parentId, subRetailer) {
    return apiClient
      .patch('retailers/' + parentId + '/sub-retailers/' + retailerId, subRetailer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBrands(retailerId, categoryId) {
    const url = categoryId ? '/brands?category_id=' + categoryId : '/brands'
    return apiClient
      .get('retailers/' + retailerId + url)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuotationItems(retailerId, query) {
    return apiClient
      .get(`retailers/${retailerId}/quotation-items`, {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachBrand(retailerId, categoryId, brands) {
    return apiClient
      .post('retailers/' + retailerId + '/brands', {
        categoryId: categoryId,
        brands: brands
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeBrand(retailerId, categoryId, brandId) {
    return apiClient
      .post('retailers/' + retailerId + '/brands/' + brandId, {
        categoryId: categoryId
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDocuments(retailerId) {
    return apiClient
      .get('retailers/' + retailerId + '/documents')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadRetailerDocument(form) {
    let formData = new FormData()
    formData.append('file', form.form.file)
    formData.append('type', form.type)
    formData.append('retailer_id', form.retailerId)
    formData.append('name', form.form.name)

    return apiClient
      .postForm('retailers/' + form.retailerId + '/upload-document', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeRetailerDocument(params) {
    return apiClient
      .delete('/retailers/' + params.retailerId + '/documents/' + params.id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  downloadRetailerDocument(params) {
    return apiClient
      .get('retailers/' + params.retailerId + '/download-document/' + params.id, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportRetailersCurrentAccounts(query) {
    return apiClient
      .get('retailers/current-account/export?', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleForwardSalesChannelOverriddenStatus(retailerId) {
    return apiClient
      .post('retailers/' + retailerId + '/toggle-forward-sales-channel-overridden-status')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleFarmerPaidOrderCheckOverriddenStatus(retailerId) {
    return apiClient
      .post('retailers/' + retailerId + '/toggle-farmer-paid-order-check-overridden-status')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleShortSaleOverriddenStatus(retailerId) {
    return apiClient
      .post('retailers/' + retailerId + '/toggle-short-sale-overridden-status')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleSalesChannelStatuses(retailerId) {
    return apiClient
      .post('retailers/' + retailerId + '/toggle-sales-channel-statuses')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getShortSaleActivity(retailerId) {
    return apiClient
      .get('retailers/' + retailerId + '/short-sale-activity')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannelsStatusHistory(retailerId) {
    return apiClient
      .get('retailers/' + retailerId + '/sales-channel-status-history')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getIsPayableHistory(retailerId, params) {
    return apiClient
      .get('retailers/' + retailerId + '/is-payable-history', {
        params
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  togglePaidPromissoryNotesShipping(retailerId) {
    return apiClient
      .patch('retailers/' + retailerId + '/toggle-paid-promissory-notes-shipping')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateIsPayable(retailerId, isPayable) {
    return apiClient
      .patch('retailers/' + retailerId + '/update-is-payable', {
        is_payable: isPayable
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateRank(retailerId, rankId) {
    return apiClient
      .patch('retailers/' + retailerId + '/update-rank', {
        rank_id: rankId
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerContacts(id) {
    return apiClient
      .get('retailers/' + id + '/contacts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
